module.exports = __webpack_public_path__ + "img/contact-button.1d36f505.png";